// 管理后台翻译 - 专家管理、专家配置等

export const zh = {
  // 用户管理·添加（v3.5.1）
  addUser: '添加用户',
  phonePlaceholder: '手机号（验证码登录身份）',
  initialPasswordLabel: '初始密码',
  pwdModeNone: '不设置',
  pwdModeRandom: '系统随机',
  pwdModeCustom: '自定义',
  pwdNoneHint: '不设密码：用户用手机验证码登录，首次收到验证码即可进入；设置初始密码则也可用密码登录。',
  userCreated: '用户已创建',
  userCreateFailed: '创建失败',
  // 用户管理（v3.5）
  searchUsers: '搜索用户 / 手机号 / 邮箱…',
    auditLog: '审计日志',
  auditSearch: '搜索操作者 / 动作 / 对象…',
  auditCount: '共 {count} 条',
  memoryManagement: '记忆管理',
  memorySearch: '搜索记忆内容…',
  memoryCount: '共 {count} 条记忆',
  memoryEmpty: '暂无长期记忆',
  memoryColTime: '时间',
  memoryColUser: '用户',
  memoryColContent: '记忆内容',
  memoryColType: '类型',
  pageIndicator: '第 {page} / {total} 页',
  auditEmpty: '暂无审计记录',
  auditColTime: '时间',
  auditColActor: '操作者',
  auditColAction: '动作',
  auditColTarget: '对象',
  searchRuns: '搜索运行 ID / 用户名…',
  colUser: '用户',
  colPhone: '手机号',
  colEmail: '邮箱',
  colUuid: 'UUID',
  colCreatedAt: '注册时间',
  colLastLogin: '最近登录',
  colRole: '角色',
  colActions: '操作',
  userCount: '{count} 位用户',
  userNoMatch: '没有匹配的用户',
  selfTag: '我',
  revealPhone: '查看完整手机号',
  maskPhone: '隐藏手机号',
  revealPhoneFailed: '获取手机号失败',
  userNameLabel: '用户名',
  emailLabel: '邮箱',
  emailPlaceholder: '未绑定',
  phoneLabel: '手机号',
  userRoleLabel: '用户角色',
  roleAdmin: '管理员',
  roleUser: '普通用户',
  selfRoleLockedHint: '不能修改自己的角色（防止最后一个管理员自锁）。',
  selfDeleteLockedHint: '不能删除当前登录的账号',
  resetPasswordLabel: '重置密码',
  resetModeRandom: '系统随机',
  resetModeCustom: '自定义密码',
  resetCustomPlaceholder: '输入新密码（≥8 位）',
  resetApply: '重置',
  resetGenerate: '生成随机密码',
  resetModeHint: '随机密码生成后仅显示一次；不通过短信发送，请通过可信渠道交付给用户。',
  resetDeliverHint: '新密码已生成，只显示这一次。请立即复制并通过可信渠道（当面 / 内部通讯）交付给用户。',
  resetPasswordTooShort: '自定义密码至少 8 位',
  resetPasswordOk: '密码已重置',
  resetPasswordFailed: '重置密码失败',
  userSaved: '用户信息已保存',
  userSaveFailed: '保存失败',
  userDeleted: '用户已删除',
  userDeleteFailed: '删除失败',
  userDeleteTitle: '确认删除用户',
  userDeleteWarning: '将删除 {name} 的账号、全部会话与产物数据，此操作不可恢复。',
  // Expert Admin Page - additional keys
  refreshSuccess: '刷新成功',
  config: '配置',
  conservative: '保守',
  balanced: '平衡',
  creative: '创意',
  minChars: '最少字符',
  testInputMinCharsError: '测试输入至少需要 10 个字符',
  executionCompleted: '执行完成',
  secondsAbbr: '秒',
  temp: '温度',
  response: '响应',

  // RBAC Expert Admin (v0.6.0)
  refresh: '刷新',
  lastUpdated: '最后更新',
  expertKey: '专家标识',
  model: '模型',
  provider: '提供商',
  temperature: '温度参数',
  saveConfig: '保存配置',
  saveSuccess: '专家配置已更新，下次任务生效',
  saveFailed: '无法保存专家配置',
  previewMode: '预览模式',
  editMode: '编辑模式',
  startPreview: '开始预览',
  previewFailed: '预览失败',
  testInput: '测试输入',
  testInputPlaceholder: '输入测试文本（至少 10 个字符）...',
  testInputMinChars: '{count} / 10 最小字符',
  previewResults: '预览结果',
  seconds: '{time} 秒',

  // Expert Description (v0.7.0)
  expertDescription: '能力描述 (Description)',
  expertDescriptionPlaceholder: '能力包：输入 X → 产出 Y（产物形态）。适用：哪类任务应路由到此。例：能力包：代码生成。输入需求 → 产出可运行的完整代码文件。适用：编写程序/脚本、修改既有代码。',
  expertDescriptionTooltip: '这段文字将被发送给 Planner，用于决定何时将任务分配给该专家',
  autoGenerate: '✨ 自动生成',
  autoGenerateDescriptionTooltip: '根据当前的 System Prompt 自动总结专家能力',
  generating: '生成中...',
  descriptionGenerated: '描述已生成',
  generateDescriptionFailed: '生成描述失败',
  systemPromptTooShort: 'System Prompt 太短，无法生成描述',

  // Dynamic Expert (v3.0)
  createExpert: '创建专家',
  dynamicExpert: '自定义',
  builtinExpert: '内置',
  deleteExpert: '删除专家',
  confirmDeleteExpert: '确认删除专家',
  deleteExpertWarning: "确定要删除专家 '{name}' 吗？此操作无法撤销。",
  expertKeyPlaceholder: '例如：xiaohongshu_writer',
  expertKeyHint: '只能包含小写字母、数字和下划线，以小写字母开头',
  namePlaceholder: '例如：小红书文案专家',
  creating: '创建中...',
  createSuccess: '创建成功',
  createFailed: '创建失败',
  deleteSuccess: '删除成功',
  cannotDeleteSystemExpert: '系统内置专家不可删除',
  editExpert: '编辑专家',
  loadExpertsFailed: '专家列表加载失败',

  // Tool Tips (v3.1)
  showToolTips: '工具使用指南',
  hideToolTips: '收起指南',
  toolTipsDescription: '专家可以调用以下工具来增强能力，建议在 System Prompt 中指导何时使用',
  toolUsageExample: '使用示例',
  loadingTools: '加载工具列表中...',
  // —— 自 common.ts 按域迁入 ——
  create: '创建',
  description: '描述',
  systemPrompt: '系统提示词',
  systemPromptPlaceholder: '你是一个专业的助手，擅长...',
}

export const en = {
  // 用户管理·添加（v3.5.1）
  addUser: 'Add user',
  phonePlaceholder: 'Phone number (OTP login identity)',
  initialPasswordLabel: 'Initial password',
  pwdModeNone: 'None',
  pwdModeRandom: 'System random',
  pwdModeCustom: 'Custom',
  pwdNoneHint: 'No password: the user signs in with SMS verification code. With an initial password, password login also works.',
  userCreated: 'User created',
  userCreateFailed: 'Failed to create user',
  // 用户管理（v3.5）
  searchUsers: 'Search users / phone / email…',
    auditLog: 'Audit Log',
  auditSearch: 'Search actor / action / target…',
  auditCount: '{count} entries',
  memoryManagement: 'Memories',
  memorySearch: 'Search memory content…',
  memoryCount: '{count} memories',
  memoryEmpty: 'No long-term memories',
  memoryColTime: 'Time',
  memoryColUser: 'User',
  memoryColContent: 'Content',
  memoryColType: 'Type',
  pageIndicator: 'Page {page} of {total}',
  auditEmpty: 'No audit entries',
  auditColTime: 'Time',
  auditColActor: 'Actor',
  auditColAction: 'Action',
  auditColTarget: 'Target',
  searchRuns: 'Search run ID / username…',
  colUser: 'User',
  colPhone: 'Phone',
  colEmail: 'Email',
  colUuid: 'UUID',
  colCreatedAt: 'Registered',
  colLastLogin: 'Last login',
  colRole: 'Role',
  colActions: 'Actions',
  userCount: '{count} users',
  userNoMatch: 'No matching users',
  selfTag: 'me',
  revealPhone: 'Reveal full phone number',
  maskPhone: 'Mask phone number',
  revealPhoneFailed: 'Failed to get phone number',
  userNameLabel: 'Username',
  emailLabel: 'Email',
  emailPlaceholder: 'Not set',
  phoneLabel: 'Phone',
  userRoleLabel: 'Role',
  roleAdmin: 'Admin',
  roleUser: 'Member',
  selfRoleLockedHint: 'You cannot change your own role (protects the last admin).',
  selfDeleteLockedHint: 'You cannot delete the account you are signed in with',
  resetPasswordLabel: 'Reset password',
  resetModeRandom: 'System random',
  resetModeCustom: 'Custom password',
  resetCustomPlaceholder: 'Enter new password (min 8 chars)',
  resetApply: 'Reset',
  resetGenerate: 'Generate random password',
  resetModeHint: 'The random password is shown only once; it is never sent by SMS. Hand it to the user over a trusted channel.',
  resetDeliverHint: 'New password generated — shown only this once. Copy it now and deliver via a trusted channel (in person / internal chat).',
  resetPasswordTooShort: 'Custom password must be at least 8 characters',
  resetPasswordOk: 'Password reset',
  resetPasswordFailed: 'Failed to reset password',
  userSaved: 'User saved',
  userSaveFailed: 'Save failed',
  userDeleted: 'User deleted',
  userDeleteFailed: 'Delete failed',
  userDeleteTitle: 'Delete user',
  userDeleteWarning: "This deletes {name}'s account, all conversations and artifacts. This cannot be undone.",
  // Expert Admin Page - additional keys
  refreshSuccess: 'Refresh successful',
  config: 'Config',
  conservative: 'Conservative',
  balanced: 'Balanced',
  creative: 'Creative',
  minChars: 'Min chars',
  testInputMinCharsError: 'Test input must be at least 10 characters',
  executionCompleted: 'Execution completed',
  secondsAbbr: 's',
  temp: 'Temp',
  response: 'Response',

  // RBAC Expert Admin (v0.6.0)
  refresh: 'Refresh',
  lastUpdated: 'Last Updated',
  expertKey: 'Expert Key',
  model: 'Model',
  provider: 'Provider',
  temperature: 'Temperature',
  saveConfig: 'Save Configuration',
  saveSuccess: 'Expert configuration updated, will take effect on next task',
  saveFailed: 'Failed to save expert configuration',
  previewMode: 'Preview Mode',
  editMode: 'Edit Mode',
  startPreview: 'Start Preview',
  previewFailed: 'Preview Failed',
  testInput: 'Test Input',
  testInputPlaceholder: 'Enter test text (minimum 10 characters)...',
  testInputMinChars: '{count} / 10 minimum characters',
  previewResults: 'Preview Results',
  seconds: '{time} seconds',

  // Expert Description (v0.7.0)
  expertDescription: 'Capability Description (Description)',
  expertDescriptionPlaceholder: 'Capability: input X → output Y (artifact form). Applicable: which tasks route here. E.g. Capability: code generation. Input requirements → output runnable complete code files. Applicable: writing programs/scripts, editing existing code.',
  expertDescriptionTooltip: 'This text will be sent to the Planner to determine when to assign tasks to this expert',
  autoGenerate: '✨ Auto-Generate',
  autoGenerateDescriptionTooltip: 'Automatically summarize expert capabilities based on current System Prompt',
  generating: 'Generating...',
  descriptionGenerated: 'Description generated',
  generateDescriptionFailed: 'Failed to generate description',
  systemPromptTooShort: 'System Prompt is too short to generate description',

  // Dynamic Expert (v3.0)
  createExpert: 'Create Expert',
  dynamicExpert: 'Custom',
  builtinExpert: 'Built-in',
  deleteExpert: 'Delete Expert',
  confirmDeleteExpert: 'Confirm Delete Expert',
  deleteExpertWarning: "Are you sure you want to delete the expert '{name}'? This action cannot be undone.",
  expertKeyPlaceholder: 'e.g., xiaohongshu_writer',
  expertKeyHint: 'Lowercase letters, numbers, and underscores only, start with a letter',
  namePlaceholder: 'e.g., Xiaohongshu Copywriter',
  creating: 'Creating...',
  createSuccess: 'Created successfully',
  createFailed: 'Failed to create',
  deleteSuccess: 'Deleted successfully',
  cannotDeleteSystemExpert: 'System built-in experts cannot be deleted',
  editExpert: 'Edit Expert',
  loadExpertsFailed: 'Failed to load experts',

  // Tool Tips (v3.1)
  showToolTips: 'Tool Usage Guide',
  hideToolTips: 'Hide Guide',
  toolTipsDescription: 'Experts can use these tools to enhance capabilities. Guide when to use them in System Prompt',
  toolUsageExample: 'Usage Example',
  loadingTools: 'Loading tools...',
  // —— 自 common.ts 按域迁入 ——
  create: 'Create',
  description: 'Description',
  systemPrompt: 'System Prompt',
  systemPromptPlaceholder: 'You are a helpful assistant who specializes in...',
}

export const ja = {
  // ユーザー管理・追加（v3.5.1）
  addUser: 'ユーザーを追加',
  phonePlaceholder: '電話番号（認証コードログイン用）',
  initialPasswordLabel: '初期パスワード',
  pwdModeNone: '設定しない',
  pwdModeRandom: 'システム生成',
  pwdModeCustom: 'カスタム',
  pwdNoneHint: 'パスワードなし：ユーザーはSMS認証コードでログインします。初期パスワードを設定するとパスワードログインも有効になります。',
  userCreated: 'ユーザーを作成しました',
  userCreateFailed: '作成に失敗しました',
  // ユーザー管理（v3.5）
  searchUsers: 'ユーザー / 電話 / メールを検索…',
    auditLog: '監査ログ',
  auditSearch: '操作者 / アクション / 対象を検索…',
  auditCount: '全 {count} 件',
  memoryManagement: '記憶管理',
  memorySearch: '記憶内容を検索…',
  memoryCount: '全 {count} 件の記憶',
  memoryEmpty: '長期記憶はありません',
  memoryColTime: '時刻',
  memoryColUser: 'ユーザー',
  memoryColContent: '記憶内容',
  memoryColType: 'タイプ',
  pageIndicator: '{page} / {total} ページ',
  auditEmpty: '監査記録はありません',
  auditColTime: '時刻',
  auditColActor: '操作者',
  auditColAction: 'アクション',
  auditColTarget: '対象',
  searchRuns: '実行ID / ユーザー名を検索…',
  colUser: 'ユーザー',
  colPhone: '電話番号',
  colEmail: 'メール',
  colUuid: 'UUID',
  colCreatedAt: '登録日',
  colLastLogin: '最終ログイン',
  colRole: 'ロール',
  colActions: '操作',
  userCount: '{count} 人のユーザー',
  userNoMatch: '該当するユーザーがいません',
  selfTag: '自分',
  revealPhone: '完全な電話番号を表示',
  maskPhone: '電話番号を隠す',
  revealPhoneFailed: '電話番号の取得に失敗しました',
  userNameLabel: 'ユーザー名',
  emailLabel: 'メール',
  emailPlaceholder: '未設定',
  phoneLabel: '電話番号',
  userRoleLabel: 'ユーザーロール',
  roleAdmin: '管理者',
  roleUser: 'メンバー',
  selfRoleLockedHint: '自分のロールは変更できません（最後の管理者の締め出し防止）。',
  selfDeleteLockedHint: '現在ログイン中のアカウントは削除できません',
  resetPasswordLabel: 'パスワードのリセット',
  resetModeRandom: 'システム生成',
  resetModeCustom: 'カスタムパスワード',
  resetCustomPlaceholder: '新しいパスワード（8文字以上）',
  resetApply: 'リセット',
  resetGenerate: 'ランダムパスワードを生成',
  resetModeHint: 'ランダムパスワードは一度だけ表示されます。SMS では送信されないため、信頼できる経路でユーザーへ伝えてください。',
  resetDeliverHint: '新しいパスワードが生成されました。この一度しか表示されないので、今すぐコピーしてユーザーに安全に伝えてください。',
  resetPasswordTooShort: 'パスワードは8文字以上必要です',
  resetPasswordOk: 'パスワードをリセットしました',
  resetPasswordFailed: 'パスワードのリセットに失敗しました',
  userSaved: 'ユーザー情報を保存しました',
  userSaveFailed: '保存に失敗しました',
  userDeleted: 'ユーザーを削除しました',
  userDeleteFailed: '削除に失敗しました',
  userDeleteTitle: 'ユーザーを削除',
  userDeleteWarning: '{name} のアカウント、すべての会話と成果物が削除されます。この操作は元に戻せません。',
  // Expert Admin Page - additional keys
  refreshSuccess: '更新成功',
  config: '設定',
  conservative: '保守的',
  balanced: 'バランス',
  creative: '創造的',
  minChars: '最小文字数',
  testInputMinCharsError: 'テスト入力は最低10文字必要です',
  executionCompleted: '実行完了',
  secondsAbbr: '秒',
  temp: '温度',
  response: '応答',

  // RBAC Expert Admin (v0.6.0)
  refresh: '更新',
  lastUpdated: '最終更新',
  expertKey: 'エキスパートキー',
  model: 'モデル',
  provider: 'プロバイダー',
  temperature: '温度',
  saveConfig: '設定を保存',
  saveSuccess: 'エキスパート設定が更新され、次回タスクから有効',
  saveFailed: 'エキスパート設定を保存できません',
  previewMode: 'プレビューモード',
  editMode: '編集モード',
  startPreview: 'プレビュー開始',
  previewFailed: 'プレビュー失敗',
  testInput: 'テスト入力',
  testInputPlaceholder: 'テストテキストを入力（最低10文字）...',
  testInputMinChars: '{count} / 10 最小文字',
  previewResults: 'プレビュー結果',
  seconds: '{time} 秒',

  // Expert Description (v0.7.0)
  expertDescription: '能力説明 (Description)',
  expertDescriptionPlaceholder: '能力パック：入力 X → 产出 Y（成果物の形態）。適用：どのタスクをここに振るか。例：能力パック：コード生成。要件 → 実行可能な完全なコードファイル。適用：プログラム作成・既存コード修正。',
  expertDescriptionTooltip: 'このテキストはPlannerに送信され、このエキスパートにタスクを割り当てるかどうかを決定します',
  autoGenerate: '✨ 自動生成',
  autoGenerateDescriptionTooltip: '現在のSystem Promptに基づいてエキスパートの能力を自動的に要約',
  generating: '生成中...',
  descriptionGenerated: '説明が生成されました',
  generateDescriptionFailed: '説明の生成に失敗しました',
  systemPromptTooShort: 'System Promptが短すぎて説明を生成できません',

  // Dynamic Expert (v3.0)
  createExpert: 'エキスパートを作成',
  dynamicExpert: 'カスタム',
  builtinExpert: '内蔵',
  deleteExpert: 'エキスパートを削除',
  confirmDeleteExpert: 'エキスパート削除の確認',
  deleteExpertWarning: "エキスパート'{name}'を削除してもよろしいですか？この操作は取り消せません。",
  expertKeyPlaceholder: '例：xiaohongshu_writer',
  expertKeyHint: '小文字、数字、アンダースコアのみ、小文字で開始',
  namePlaceholder: '例：小紅書コピーライター',
  creating: '作成中...',
  createSuccess: '作成しました',
  createFailed: '作成に失敗しました',
  deleteSuccess: '削除しました',
  cannotDeleteSystemExpert: 'システム組み込みのエキスパートは削除できません',
  editExpert: 'エキスパートを編集',
  loadExpertsFailed: 'エキスパート一覧の取得に失敗しました',

  // Tool Tips (v3.1)
  showToolTips: 'ツール使用ガイド',
  hideToolTips: 'ガイドを閉じる',
  toolTipsDescription: 'エキスパートは以下のツールを使用して能力を強化できます。System Promptで使用タイミングを指導してください',
  toolUsageExample: '使用例',
  loadingTools: 'ツールリスト読み込み中...',
  // —— 自 common.ts 按域迁入 ——
  create: '作成',
  description: '説明',
  systemPrompt: 'システムプロンプト',
  systemPromptPlaceholder: 'あなたは専門的なアシスタントで、...',
}
